import { call, all, put, takeLatest } from "redux-saga/effects";
import { AxiosResponse } from "axios";

import {
  onboardingTypes as types,
  setOnboarding,
  setSingleOnboarding,
} from "../actions";
import {
  getOnboardingByIdService,
  getOnboardingService,
} from "../../../services/learner/onboarding";
import { EntityIdPayload } from "../../../utils";

export default function* learnerOnboardingSagas() {
  yield all([
    takeLatest(types.GET_ONBOARDING, handleGetOnboarding),
    takeLatest(types.GET_SINGLE_ONBOARDING, handleGetOnboardingById),
  ]);
}

function* handleGetOnboarding() {
  const { data }: AxiosResponse = yield call(getOnboardingService);
  if (data) {
    yield put(setOnboarding({ onboardings: data }));
  }
}

function* handleGetOnboardingById(action: EntityIdPayload) {
  const { data }: AxiosResponse = yield call(
    getOnboardingByIdService,
    action.payload.id
  );
  if (data) {
    const extendedOnboardingSteps = extendOnboardingWithType(data?.steps);
    yield put(
      setSingleOnboarding({
        onboarding: {
          ...data,
          steps: extendedOnboardingSteps,
        },
      })
    );
  }
}

function extendOnboardingWithType(steps: any) {
  let foundFirstUnfinished = false;
  let foundFirstDisapproved = false;

  return steps
    .sort((a: any, b: any) => a.orderIndex - b.orderIndex)
    .map((step: any) => {
      if (
        !step.task &&
        !foundFirstUnfinished &&
        !foundFirstDisapproved &&
        !step.isFinished
      ) {
        foundFirstUnfinished = true;
        return setStepState(step, false);
      }

      if (
        step.task &&
        !foundFirstDisapproved &&
        !foundFirstUnfinished &&
        !step.isApproved
      ) {
        foundFirstDisapproved = true;
        return setStepState(step, false);
      }

      return setStepState(step, true);
    });
}

const setStepState = (step: any, locked: boolean) => {
  return {
    ...step,
    locked,
    type: !!step.module
      ? "Module"
      : !!step.course
      ? "Course"
      : !!step.lesson
      ? "Lesson"
      : !!step.quizzie
      ? "Quizzie"
      : !!step.task
      ? "Task"
      : null,
  };
};
